export const SMALL_FALLBACK_PRODUCT_IMAGE_URL =
  'https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/calculator/fallback_product_image.png/fallback_product_image.png';
export const FALLBACK_PRODUCT_IMAGE_URL =
  'https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/calculator/fallback_product_image.png/fallback_product_image.png';
